import MenuItem from '@material-ui/core/MenuItem';
/**
 * Import da biblioteca "styled-components", que permite escrever 
 * CSS simples para os componentes sem acontecer conflitos com os 
 * nomes das clases, são escritos entre Tagged Templates Literals(``).
 */
 import styled from 'styled-components';

/**
 * Estilização do componente StyledMenuItem
 */
 export const StyledMenuItem = styled(MenuItem)`
 font-size: 14px;

 textarea {
   height: 0;
   width: 0;
   opacity: 0;
   display: inline;
 }

 &:focus {
   text-decoration: none;
   color: inherit;
   outline: none;
 }
`;